import type { JSX } from 'react';

type VolumeIconProps = {
  className?: string;
  variant: 'max' | 'max-white' | 'mid' | 'mute' | 'mute-white';
};

const VolumeIcon = (props: VolumeIconProps): JSX.Element => {
  const { className, variant } = props;
  switch (variant) {
    case 'max':
      return (
        <svg
          className={className || ''}
          viewBox="0 -4 32 31"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.1827 1.08915C25.4854 0.786624 25.9759 0.786698 26.2785 1.08932C32.2269 7.0396 32.2269 16.685 26.2785 22.6353C25.9759 22.9379 25.4854 22.938 25.1827 22.6355C24.8801 22.3329 24.88 21.8424 25.1826 21.5397C30.5261 16.1946 30.5261 7.53005 25.1826 2.18488C24.88 1.88226 24.8801 1.39168 25.1827 1.08915ZM20.0774 6.19452C20.38 5.89199 20.8706 5.89207 21.1731 6.19469C24.2986 9.32111 24.2986 14.389 21.1731 17.5155C20.8706 17.8181 20.38 17.8181 20.0774 17.5156C19.7747 17.2131 19.7747 16.7225 20.0772 16.4199C22.5977 13.8986 22.5977 9.81155 20.0772 7.29025C19.7747 6.98762 19.7747 6.49705 20.0774 6.19452ZM13.575 1.13333L6.55584 6.74867H1.04249C0.614587 6.74867 0.2677 7.09556 0.2677 7.52346V16.2011C0.2677 16.6291 0.614587 16.9759 1.04249 16.9759H6.55584L13.575 22.5913C14.0823 22.9971 14.8338 22.6359 14.8338 21.9863V1.73834C14.8338 1.08867 14.0823 0.727484 13.575 1.13333Z"
            fill="currentColor"
          />
        </svg>
      );
    case 'max-white':
      return (
        <svg
          className={className || ''}
          viewBox="0 -4 32 31"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.1827 1.08915C25.4854 0.786624 25.9759 0.786698 26.2785 1.08932C32.2269 7.0396 32.2269 16.685 26.2785 22.6353C25.9759 22.9379 25.4854 22.938 25.1827 22.6355C24.8801 22.3329 24.88 21.8424 25.1826 21.5397C30.5261 16.1946 30.5261 7.53005 25.1826 2.18488C24.88 1.88226 24.8801 1.39168 25.1827 1.08915ZM20.0774 6.19452C20.38 5.89199 20.8706 5.89207 21.1731 6.19469C24.2986 9.32111 24.2986 14.389 21.1731 17.5155C20.8706 17.8181 20.38 17.8181 20.0774 17.5156C19.7747 17.2131 19.7747 16.7225 20.0772 16.4199C22.5977 13.8986 22.5977 9.81155 20.0772 7.29025C19.7747 6.98762 19.7747 6.49705 20.0774 6.19452ZM13.575 1.13333L6.55584 6.74867H1.04249C0.614587 6.74867 0.2677 7.09556 0.2677 7.52346V16.2011C0.2677 16.6291 0.614587 16.9759 1.04249 16.9759H6.55584L13.575 22.5913C14.0823 22.9971 14.8338 22.6359 14.8338 21.9863V1.73834C14.8338 1.08867 14.0823 0.727484 13.575 1.13333Z"
            fill="#fff"
          />
        </svg>
      );
    case 'mid':
      return (
        <svg
          className={className || ''}
          viewBox="2 2 32 31"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.5 7.5L9 13.5H3V22.5H9L16.5 28.5V7.5Z"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M23.3101 12.6899C24.7161 14.0964 25.506 16.0037 25.506 17.9924C25.506 19.9812 24.7161 21.8885 23.3101 23.2949"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'mute':
      return (
        <svg className={className || ''} viewBox="0 -5 32 31" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.7857 0L6.92854 6.28571H0.642822V15.7143H6.92854L14.7857 22V0V0Z"
            fill="currentColor"
          />
          <path
            d="M33.6428 6.28564L24.2142 15.7142"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M24.2142 6.28564L33.6428 15.7142"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'mute-white':
      return (
        <svg className={className || ''} viewBox="0 -5 32 31" fill="#fff">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.7857 0L6.92854 6.28571H0.642822V15.7143H6.92854L14.7857 22V0V0Z"
            fill="#fff"
          />
          <path
            d="M33.6428 6.28564L24.2142 15.7142"
            stroke="#fff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M24.2142 6.28564L33.6428 15.7142"
            stroke="#fff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    default:
      return <></>;
  }
};
export default VolumeIcon;
